export const ORDER_TYPES = {
    ALL: "All",
    DELIVERY: "Delivery",
    PICKUP: "Pickup",
    MIXED: "Mixed",
};

export const ORDER_TYPE_OPTIONS = [
    { label: ORDER_TYPES.ALL, value: ORDER_TYPES.ALL },
    { label: ORDER_TYPES.DELIVERY, value: ORDER_TYPES.DELIVERY },
    { label: ORDER_TYPES.PICKUP, value: ORDER_TYPES.PICKUP },
    { label: ORDER_TYPES.MIXED, value: ORDER_TYPES.MIXED },
];

export const TIME_PERIODS = {
    MONTHLY: "Monthly",
    PAST_3: "Past 3 months",
    PAST_6: "Past 6 months",
    YTD: "Year to date",
};

export const TIME_PERIOD_OPTIONS = [
    TIME_PERIODS.MONTHLY,
    TIME_PERIODS.PAST_3,
    TIME_PERIODS.PAST_6,
    TIME_PERIODS.YTD,
];

export const DEFAULT_FILTERS = {
    orderType: ORDER_TYPES.ALL,
    branch: [],
    timePeriod: TIME_PERIODS.MONTHLY,
    month: new Date().toISOString().slice(0, 7),
};

export const VIEW_STATES = {
    LOADING: "loading",
    READY: "ready",
    EMPTY: "empty",
    ERROR: "error",
};

export const CARD_TITLES = [
    "Technician Arrival",
    "Equipment Condition",
    "Technician Service",
];

export const CARD_DESCRIPTIONS = [
    "Did the technician arrive on time for delivery and/or pickup?",
    "Was the equipment clean and working properly when it was delivered?",
    "Did the technician explain how to use the equipment clearly and respectfully?",
];

export const GRANULARITY = {
    WEEKLY: "weekly",
    MONTHLY: "monthly",
};
